import { Injectable } from '@angular/core';
import { RequestService } from '../requestService/request.service';

@Injectable({
  providedIn: 'root'
})
export class ViewingService {

  constructor(private requestService: RequestService) { }

  // Remove items from viewing history
  removeViewingHistory(ids) {
    let req = {
      url: "/api/personalizedContent/deleteViewingHistory",
      req: {
        viewingHistoryIds: ids
      }
    };
    return this.requestService.mainPostRequest(req);
  }

  // Get Viewing History List
  getViewingHistory(params) {
    let req = {
      url: "/api/personalizedContent/getMyViewingHistory",
      req: {
        count: params.count ? params.count : 20,
        offset: params.offset ? params.offset : 0
      }
    };
    return this.requestService.mainPostRequest(req);
  }
}